/**
 * Cron / poll quiet mode:
 * - Hold mode (redux cronJobs): each tick replaces a buffer; STOP flushes last tick only.
 * - Drop mode (token refresh): never export those spans.
 */
let quietDepth = 0;
let dropDepth = 0;
/** @type {import('@opentelemetry/sdk-trace-base').ReadableSpan[]} */
let heldSpans = [];
/** @type {((span: import('@opentelemetry/sdk-trace-base').ReadableSpan) => void) | null} */
let flushSink = null;

export const OTEL_ATTR_CRON_POLL = 'app.cron_poll';
export const OTEL_ATTR_CRON_POLL_DROP = 'app.cron_poll_drop';

export function isPollQuiet() {
  return quietDepth > 0 || dropDepth > 0;
}

export function isPollDrop() {
  return dropDepth > 0;
}

export function beginCronPollTick() {
  // Drop previous tick — only the latest poll should survive until stop.
  heldSpans = [];
  quietDepth += 1;
}

export function endCronPollTick() {
  if (quietDepth > 0) quietDepth -= 1;
}

export function holdCronPollSpan(span) {
  heldSpans.push(span);
}

export function setCronPollFlushSink(fn) {
  flushSink = typeof fn === 'function' ? fn : null;
}

/** Export spans from the last poll tick (call when cron job stops). */
export function flushLastCronPollSpans() {
  const batch = heldSpans;
  heldSpans = [];
  if (!flushSink || batch.length === 0) {
    return 0;
  }
  batch.forEach(span => {
    try {
      flushSink(span);
    } catch (e) {
      // ignore
    }
  });
  if (process.env.REACT_APP_ENV !== 'production' && batch.length) {
    console.log('[otel] flushed last cron poll spans', batch.length);
  }
  return batch.length;
}

/** Drop held poll spans without exporting. */
export function discardHeldCronPollSpans() {
  const n = heldSpans.length;
  heldSpans = [];
  return n;
}

/** Hold-mode wrapper (cron ticks). */
export function runInPollQuiet(fn) {
  beginCronPollTick();
  try {
    return fn();
  } finally {
    endCronPollTick();
  }
}

/** Drop-mode wrapper (token refresh — never keep). */
export function runInPollDrop(fn) {
  dropDepth += 1;
  try {
    return fn();
  } finally {
    if (dropDepth > 0) dropDepth -= 1;
  }
}
